import React from "react";
import { styled } from "@mui/material/styles";

const RootDiv = styled("div")({
    marginRight: "8rem",
    textAlign: "center",
    padding: 2,
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    //  minWidth: "500px",
});

const ContainerDiv = styled("div")({
    padding: 32,
    marginBottom: "5rem",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
});

export default function AdminProfile() {

  return (
    <RootDiv>        
        <title>R3PLAY - Admin Profile</title>               
        <ContainerDiv>
        <h1>Admin Profile</h1>
      </ContainerDiv>
    </RootDiv>
  );
}
